export const isWindows =
  typeof navigator !== 'undefined' && /Windows/i.test(navigator.userAgent);
